export default "__VITE_ASSET__D8bNNMZ6__"